export default function openIphoneLink(url: string) {
    window.location.href = url;
    // var anchor = document.createElement("a");
    // anchor.setAttribute("href", url);
    // anchor.setAttribute("target", "_blank");
    // // anchor.setAttribute("download", "downloadthisfile");
    // window.document.body.appendChild(anchor);
    // anchor.click();
}
